<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Debt collections</h1>
		<div class="margin-top">
			<Table :columns="columns" :rows="rows" />
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: false,
    saving: false,
    records: [],
    columns: {
      order: {},
      created_at: {},
      mail_to_agency_at: {},
      settled_at: {}
    }
  }),
  computed: {
    ...mapGetters([]),
    rows () {
      return this.records.map(row => {
        row.menu = []

        row.order = {
          type: 'order-link',
          order_id: row.id
        }

        if (!row.settled_at) {
          row.menu.push({
            name: 'Settle',
            onClick: row => this.settle(row.id)
          })
        } else {
          row.menu.push({
            name: 'Unsettle',
            onClick: row => this.unsettle(row.id)
          })
        }

        return row
      })
    }
  },
  methods: {
    unsettle (id) {
      Vue.$api.post('/order/' + id + '/debt-collection/unsettle', {
        comment: prompt('Please enter a comment', '')
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    settle (id) {
      Vue.$api.post('/order/' + id + '/debt-collection/settle', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    load () {
      Vue.$api.get('/debt-collection', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.records = data
    }
  },
  created () {
    this.load()
  }
}
</script>
